import type { ConnectionTestPayload } from '@Application/Security/Sso/Actions/connectionTested';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class ConnectionTestView {
	readonly succeeded: boolean;
	readonly message: string;
	readonly testedAt: string;

	constructor(payload: ConnectionTestPayload) {
		this.succeeded = payload.succeeded;
		this.message = payload.message;
		this.testedAt = payload.testedAt;

		Object.freeze(this);
	}
}

export default ConnectionTestView;
